'use client';

import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            Page Not Found
          </h2>
          <p className="text-muted-foreground mb-8">
            Looks like this page is still under construction. We&apos;re building something amazing!
          </p>
        </div>

        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={goBack}
              className="bg-primary text-primary-foreground hover:opacity-90 px-6 py-3 rounded-md font-medium transition-opacity"
            >
              Go Back
            </button>
          </div>

          <div className="text-sm text-muted-foreground">
            <p>Need help? Contact us:</p>
            <a
              href="mailto:hello@phazon.ai"
              className="text-primary hover:underline"
            >
              hello@phazon.ai
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
